// ##############################
// // // LoginPage view styles
// #############################

import pink from "@material-ui/core/colors/pink";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";

const overviewPageStyle = {
    CircularGaugeComponent: {
        marginTop: -60,
        marginBottom: -60,
    },
    AppBar: {
        backgroundColor: '#e91e63',
    },
    flex: {
        flex: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    textCenter: {
        textAlign: "center"
    },
    content: {
        paddingTop: "10px",
        paddingLeft: "10px",
        minHeight: "20vh",
        position: "relative",
        zIndex: "4",
        color: pink[600]
    },
    justifyContentCenter: {
        justifyContent: "center !important"
    },
    customButtonClass: {
        "&,&:focus,&:hover": {
            color: "#FFFFFF"
        },
        marginLeft: "5px",
        marginRight: "5px"
    },
    inputAdornment: {
        marginRight: "18px"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    socialLine: {
        padding: "0.9375rem 0"
    },
    wrapper: {
        position: 'relative',
        width: '100%',
    },
    buttonProgress: {
        color: pink[700],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    switch: {
        height: '0px'
    },
    eAcrdnHeaderContent: {
        display: 'block',
    },
    ...buttonStyle,
};

export default overviewPageStyle;
